import React, { ReactNode } from 'react';
import { classes, stylesheet } from 'typestyle';
import { Row } from '../../Utils';

interface Props {
  children?: ReactNode
  className?: string
}

function FormButtons({ className, children }: Props) {
  return (
    <Row className={classes(sheet.button, className)}>
      {children}
    </Row>
  );
}

const sheet = stylesheet({
  button: {
    justifyContent: 'space-between',
  },
});

export { FormButtons };
